var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('header',{class:[
    'checkout-header',
    `checkout-header--${_vm.appBrand}`,
  ],attrs:{"role":"banner"}},[_c('img',{staticClass:"checkout-header__logo",attrs:{"alt":_vm.logoAltText,"src":_vm.logo}}),(_vm.countryInfo)?_c('figure',{staticClass:"checkout-header__country",attrs:{"role":"img","aria-label":_vm.countryAriaLabel}},[_c('figcaption',[_vm._v(_vm._s(_vm.countryInfo.name))]),_c('div',{staticClass:"checkout-header__country-flag"},[_c('img',{attrs:{"alt":_vm.countryFlagAltText,"src":_vm.countryInfo.flag}})])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }